window.addEventListener("load", () => {
  carouselify();
});
window.addEventListener("resize", (event) => {
  carouselify();
});

var carouselify = () => {
  const carousel = document.querySelector('.quotes-carousel');
  var flkty = new Flickity( carousel, {
    prevNextButtons: false
  });
  if (window.innerWidth > 767) {
    flkty.destroy();
  };
};